<template>
  <section
    v-if="props.data?.gallerySlides?.length > 0"
    ref="componentRef"
    class="galleryTab"
    :class="[props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle']"
  >
    <div class="container col">
      <div class="row justify-content-center">
        <div
          class="galleryTab__content col s12 "
          :class="props.data.gallerySlides.length > 3
            ? 'm10 l10'
            : props.data.gallerySlides.length === 1 
              ? 'm12 l12'
              : 'm9 l9'"
        >
          <div
            class="galleryTab__content__items"
          >
            <template
              v-for="item, i in props.data.gallerySlides"
            >
              <div
                v-if="item && item.original"
                v-show="activeItem ? activeItem.original === item.original : props.data.gallerySlides[0].original === item.original"
                :key="i"
                class="galleryTab__content__item tab h-full"
              >
                <Image
                  preview
                  :alt="item.text"
                  class="w-full h-full"
                  :rotate-left-button="false"
                >
                  <template #previewicon>
                    <i class="previewIcon"></i>
                  </template>
                    
                  <template #image>
                    <nuxt-picture
                      class="h-full"
                      :img-attrs="{alt: item.text + ' ' + i++}"
                      :src="item.original"
                      sizes="sm:100vw"
                      loading="lazy"
                      :placeholder="[100, 50, 10]"
                      height="710"
                      width="1650"
                    />
                  </template>
                  
                  <template #preview="slotProps">
                    <img
                      :src="item.original"
                      :alt="item.text + ' ' + i++"
                      :style="slotProps.style"
                      @click="slotProps.onClick"
                    />
                  </template>
                </Image>
              </div>
            </template>
          </div> 
        </div>
        <div
          v-if="props.data.gallerySlides.length > 1"
          class="col s12 galleryTab__nav"
          :class="props.data.gallerySlides.length > 3 ? 'm2 l2' : 'm3 l3'"
        >
          <div
            class="galleryTab__nav__items"
          >
            <template
              v-for="item, i in props.data.gallerySlides"
            >
              <div
                v-if="item && item.original"
                :key="i"
                class="galleryTab__nav__item tab"
              >
                <div
                  class="img-holder"
                  :title="item.text"
                  :class="{active: activeItem ? activeItem.original === item.original : props.data.gallerySlides[0].original === item.original}"
                  @click="activeItem = item"
                >
                  <nuxt-picture
                    class="h-full"
                    :img-attrs="{alt: item.text + ' ' + i++}"
                    :src="item.original"
                    loading="lazy"
                    :placeholder="[100, 50, 10]"
                    height="95"
                    width="200"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div
        v-if="props.data.reviewInfo && props.data.reviewInfo.enable"
        class="galleryTab__reviews mt-4"
      >
        <HelpersReviewsItem
          :data="props.data.reviewInfo"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
const componentRef = ref(false)
const activeItem = ref(null)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.galleryTab {
  &__content {
    &__items {
      display: flex;
      height: 100%;
      margin: 0;
      @media only screen and (min-width: 601px) {
        flex-direction: column;
      }
    }
    &__item {
      width: 100%;
      height: 100%;
      padding: 5px 0;
    }
    &:deep(img) {
      width: 100%;
      height: 100%;
      border-radius: 0;

      object-fit: cover;
    }
  }
  &__nav {
    @media only screen and (min-width: 601px) {
      padding-left: 0;
    }
    @media only screen and (max-width: 600px) {
      padding-top: 5px;
    }
    &__items {
      display: flex;
      height: 100%;
      margin: 0 -5px;
      @media only screen and (min-width: 601px) {
        flex-direction: column;
      }
    }
    &__item {
      flex: 1;
      overflow: hidden;
      padding: 0 5px;
      @media only screen and (min-width: 601px) {
        display: flex;
        flex: 1 auto;
        min-height: 15%;
        max-height: 33.3%;
        padding: 5px 5px;
      }
      &:deep(img) {
        width: 100%;
        height: 100%;

        object-fit: cover;
      }
      .img-holder {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: auto;
        border: 1px solid transparent;
        transition: border-color .1s ease-in-out;
        cursor: pointer;
        @media only screen and (max-width: 600px) {
          height: 60px;
        }
        &.active {
          border-color: color("primary-color", "base");
        }
      }
    }
  }
}
</style>
